const Layout = ({ children }: { children: any }) => (
    <div className="layout">
        {children}
    </div>
);

export default Layout;
